import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.label`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    cursor: pointer;
    padding: 0 0 10px;

    & a {
        color: #111827;
        text-decoration: underline;
    }
`;

const Checkbox = styled.input`
    margin-top: 2px;
    cursor: pointer;
`;

type Props = {
    checked: boolean;
    onChange: (checked: boolean) => void;
};

export const OrderAgreement: FC<Props> = ({ checked, onChange }) => {
    return (
        <Wrapper>
            <Checkbox
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
            />
            <span>
                Совершая оплату я соглашаюсь с{' '}
                <a target="_blank" rel="noreferrer" href={process.env.PUBLIC_URL + '/Соглашение_о_возмездном_оказании_услуг_на_условиях_публичной_оферты.pdf'}>
                    Публичной Офертой
                </a>
            </span>
        </Wrapper>
    );
};
